import React from 'react';
import '../css/hero.css';
import { CgFileDocument } from "react-icons/cg";
import { FaGithub, FaLinkedin } from 'react-icons/fa';

function HeroSection() {
    return (
        <>

            <div className="framer-1w72euo" data-framer-name="Banner" style={{ willChange: "transform", opacity: "1", transform: "none" }}>
                <div className="framer-evucpe">
                    <div className="framer-1ovk579">
                        <div
                            className="framer-jp08on"
                            data-framer-appear-id="jp08on"
                            data-framer-name="Frame_20137"
                            name="Frame_20137"
                            style={{
                                opacity: 1,
                                willChange: "transform",
                                transform: "perspective(1200px)",
                            }}
                        >
                            <div className='row' style={{marginTop:"-5%"}}>
                                <div className='col-md-12 text-center' id='profile-img'>
                                    <div
                                        data-framer-background-image-wrapper="true"
                                        style={{
                                            // position: "absolute",
                                            borderRadius: "50%",
                                            inset: 0,
                                        }}
                                    >
                                        <img
                                            // decoding="async"
                                            // sizes="154px"
                                            // srcSet="./images/profile.avif"
                                            src="./images/raviPic.jpeg"
                                            alt=""
                                            style={{
                                                display: "block",
                                                width: "200px",
                                                height: "200px",
                                                borderRadius: "inherit",
                                                objectPosition: "center center",
                                                objectFit: "cover",
                                                border:"5px solid #DED1CA",
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='col-md-12 text-center mt-5'>
                                    <div
                                        className="framer-18sx012"
                                        data-framer-appear-id="18sx012"
                                        data-framer-name="Heading"
                                        data-framer-component-type="RichTextContainer"
                                        style={{
                                            outline: "none",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            opacity: 1,
                                            flexShrink: 0,
                                            willChange: "transform",
                                            transform: "perspective(1200px)",
                                        }}
                                    >
                                        <p
                                            className="framer-text"
                                            style={{
                                                fontFamily: "'Manrope', 'Manrope Placeholder', sans-serif",
                                                fontSize: "56px",
                                                fontWeight: 800,
                                                lineHeight: "120%",
                                                textAlign: "center",
                                                color: "rgb(47, 54, 63)",
                                            }}
                                        >
                                            <span
                                                data-text-fill="true"
                                                className="framer-text"
                                                style={{
                                                    color:
                                                        "#DED1CA",
                                                    WebkitBackgroundClip: "text", 
                                                    backgroundClip: "text", 
                                                    // color: "transparent", 
                                                }}
                                            >
                                                Hi, I'm Ravi :)
                                            </span>
                                        </p>
                                    </div>

                                    <div
                                        className="framer-1013w8o mt-3"
                                        data-framer-appear-id="1013w8o"
                                        data-framer-name="Heading"
                                        data-framer-component-type="RichTextContainer"
                                        style={{
                                            outline: "none",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            opacity: 1,
                                            flexShrink: 0,
                                            willChange: "transform",
                                            transform: "perspective(1200px)",
                                        }}
                                    >
                                        <p
                                            className="framer-text"
                                            style={{
                                                fontFamily: "'Manrope', 'Manrope Placeholder', sans-serif",
                                                fontSize: "24px",
                                                fontWeight: 500,
                                                lineHeight: "150%",
                                                textAlign: "center",
                                                color: "#fff",
                                            }}
                                        >
                                            Dynamic Flutter Developer with expertise in crafting seamless UI/UX designs using Figma and Illustrator. Skilled in Dart and state management (Provider, Bloc, GetX), I bring innovative ideas to life through clean, efficient code. Passionate about logo design, Flutter development, and exploring data science to create impactful digital solutions.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div className='row mt-5 links' style={{ marginLeft: "30%" }}>
                    <div className='col-md-3'>
                        <a
                            href="#!"
                            target="_blank"
                            rel="noopener"
                            style={{
                                textDecoration: "none",
                                color: "#DED1CA",
                                fontSize: "20px",
                                display: "flex",
                                alignItems: "center"
                            }}
                            className="social-link"
                        >
                            <CgFileDocument style={{ fontSize: "25px", marginRight: "10px" }} />
                            Resume
                        </a>
                    </div>
                    <div className='col-md-3'>
                        <a
                            href="https://www.linkedin.com/in/rvkt/"
                            target="_blank"
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                                color: "#DED1CA",
                                fontSize: "20px",
                                display: "flex",
                                alignItems: "center"
                            }}
                            className="social-link"
                        >
                            <FaLinkedin style={{ fontSize: "25px", marginRight: "10px" }} />
                            Linkedin
                        </a>
                    </div>
                    
                    <div className='col-md-3'>
                        <a
                            href="https://github.com/Rvkt"
                            target="_blank"
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                                color: "#DED1CA",
                                fontSize: "20px",
                                display: "flex",
                                alignItems: "center"
                            }}
                            className="social-link"
                        >
                            <FaGithub style={{ fontSize: "25px", marginRight: "10px" }} />
                            Github
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeroSection